module.exports = __webpack_public_path__ + "img/217.wall_painting.94b7a797.svg";